module.exports = __webpack_public_path__ + "static/media/b2.9892a926.png";